import { methods } from "@/mocks/gossipData";

const tone = [
  "bg-sign-500",
  "bg-melon-500",
  "bg-sun-500",
  "bg-ink-800",
  "bg-sign-600",
  "bg-melon-600",
];

export default function Methods() {
  return (
    <section id="method" className="scroll-mt-20 bg-paper-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <div className="grid gap-6 lg:grid-cols-[0.8fr_1.2fr] lg:items-end">
          <div>
            <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-melon-600">
              6 Core Methods
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-ink-950 md:text-3xl">
              吃瓜推理工法六式
            </h2>
            <p className="mt-3 text-sm leading-7 text-ink-500">
              从直觉到证据，从细节到全貌。这六套方法可以单独使用，也可以像拼图一样叠起来，构成属于你自己的完整吃瓜逻辑。
            </p>
          </div>
          <div className="hidden items-center justify-end gap-3 lg:flex">
            <span className="h-px flex-1 bg-ink-800/15" />
            <span className="whitespace-nowrap rounded-md bg-sign-500 px-4 py-2 text-sm font-semibold text-paper-50">
              由浅入深，逐式修炼
            </span>
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {methods.map((m, i) => (
            <article
              key={m.title}
              className="group relative overflow-hidden rounded-xl border border-ink-800/10 bg-paper-50 p-6 transition-colors hover:border-sign-300"
            >
              <span className="absolute right-4 top-3 font-display text-4xl font-bold text-paper-200 transition-colors group-hover:text-sign-200">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="relative">
                <div className="flex items-center gap-3">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-md ${tone[i]} text-paper-50`}
                  >
                    <i className={`text-xl ${m.icon}`} />
                  </span>
                  <span className="rounded-full border border-ink-800/15 px-2.5 py-1 text-[11px] font-semibold text-ink-500">
                    {m.step}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-ink-900">{m.title}</h3>
                <p className="mt-2 text-sm leading-7 text-ink-500">{m.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {m.points.map((p) => (
                    <span
                      key={p}
                      className="rounded-full bg-melon-100 px-2.5 py-1 text-xs font-medium text-melon-700"
                    >
                      {p}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}